<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}

.title-box-name {
  width: 110px;
  flex-shrink: 0;
  text-align: right;
}

.title-box-name span {
  color: red;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div required">公司名称</div>
          <el-select v-model="page.tenantGuid" placeholder="请选择" filterable class="ipt-sty" @change="companyChange">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="6">
          <div class="search-area-div">维护状态</div>
          <el-select v-model="page.maintainState" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in maintenanceStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="6">
          <div class="search-area-div">所属省份</div>
          <el-select filterable v-model="page.province" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">商业公司</div>
          <el-input v-model="page.franchiseeName" class="ipt-sty" clearable placeholder="请输入商业公司名称"></el-input>
        </el-col>

        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="" v-show="showMore">
        <!-- <el-col :span="6">
          <div class="search-area-div">建档方式</div>
          <el-select v-model="page.filingMethod" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in filingMethodList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->
       
        <el-col :span="6">
          <div class="search-area-div">公司类型</div>
          <el-select v-model="page.property" placeholder="请选择" class="ipt-sty " clearable multiple collapse-tags>
            <el-option v-for="item in franchiseeTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.bizStateList" placeholder="请选择" multiple filterable>
            <el-option v-for="item in bizStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">指派人员</div>
          <el-input
            size="mini"
            v-model="page.belongStaffName"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否指派</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isBelong" placeholder="请选择" filterable>
            <el-option v-for="item in isBelongOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否已清洗</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isClear" placeholder="请选择" filterable>
            <el-option v-for="item in isClearList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">清洗结果</div>
          <el-select size="mini" class="ipt-sty" v-model="page.clearResult" placeholder="请选择" filterable>
            <el-option v-for="item in clearResultList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新后名称</div>
          <el-input
            size="mini"
            v-model="page.customerNameClear"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">ID</div>
          <el-input
            size="mini"
            v-model="page.guid"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">更新时间</div>
          <el-date-picker
            size="mini"
            v-model="updateTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新人</div>
          <el-input
            size="mini"
            v-model="page.updateName"
            class="ipt-sty"
            placeholder="请输入数据更新人姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.approveState" placeholder="请选择" filterable>
            <el-option v-for="item in approveStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col> 
      </el-row> -->
    </div>
    <div class=" back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area p16">
        <el-button v-if="getBtnPermissionsByName('添加商业公司')" icon="el-icon-plus" size="mini" type="info" @click="addPath">添加商业公司</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导入')" icon="el-icon-plus" size="mini" type="info" @click="batchImport">批量导入</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导出')" size="mini" type="info" @click="report"
          v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button>
        <!-- <el-button size="mini"  v-if="getBtnPermissionsByName('批量标记状态')"  @click="openMiantainState(1)"
          v-loading.fullscreen.lock="fullscreenLoading">批量标记状态</el-button> -->
        <el-button size="mini" v-if="getBtnPermissionsByName('批量分配客户')" @click="batchCustomer">批量分配客户</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导入更新状态')" size="mini"  @click="batchStateImport">批量导入更新状态</el-button>
        <el-button v-if="getBtnPermissionsByName('批量启用')" size="mini" @click="batchChangeState('Y')">批量启用</el-button>
        <el-button v-if="getBtnPermissionsByName('批量停用')" size="mini" @click="batchChangeState('S')">批量停用</el-button>
        <el-button
          v-if="getBtnPermissionsByName('数据清洗导入')"
          size="mini"
          class="fr"
          @click="cleanImport"
          >数据清洗导入</el-button
        >
        
      </div>
      <el-table ref="multipleTable" tooltip-effect="light" :data="tableData" :height="tableHeight" stripe border v-loading="tableLoading" style="width:100%"
        @selection-change="handleSelectionChange" :row-key="(row) => row.guid"
         @row-click="handleClickTableRow">
        <el-table-column type="selection" :reserve-selection="true" width="40" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="franchiseeName" min-width="240" label="商业公司名称" header-align="center" align="left"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="region" label="大区" header-align="center" width="110" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.region | region }}</template>
        </el-table-column>
        <!-- <el-table-column
          prop="updateName"
          label="更新人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.updateName || '-' }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="approveTime" label="审核时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="approveState"
          width="96"
          label="审核状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">{{
              approveStateObj[scope.row.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="bizState"
          width="96"
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.bizState" :type="type[scope.row.bizState]">{{
              bizStateObj[scope.row.bizState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="省" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.province | province }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="110" label="市" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.city | city }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="130" label="区/县" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.district | district }}</template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" min-width="240" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column
            width="110"
            label="经度"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.lng || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            width="110"
            label="纬度"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.lat || "-" }}
            </template>
          </el-table-column>
        <el-table-column prop="contacts" width="96" label="联系人" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contacts || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contactTel" width="120" label="联系电话" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contactTel || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="120" label="业务指派人员" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getbelongStaffsName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="property" width="120" label="商业公司类型" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.property || '-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="contactTel" width="150" label="建档方式" header-align="center"  align="center">
                <template slot-scope="scope">
            {{ scope.row.contactTel ||'-' }}
          </template> 
        </el-table-column> -->
        <!-- <el-table-column prop="contactTel" width="100" label="维护状态" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.maintainState | maintainState }}
          </template>
        </el-table-column> -->
        <el-table-column 
          prop="franchiseeCode" 
          width="120" 
          label="商业公司编码" 
          header-align="center" 
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.franchiseeCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="guid"
          width="280"
          label="ID"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.guid || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isClear"
          width="120"
          label="是否已清洗"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.isClear || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="customerNameClear"
          width="220"
          label="更新后商业公司名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.customerNameClear || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lngClear"
          width="120"
          label="经度清洗"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.lngClear || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="latClear"
          width="120"
          label="纬度清洗"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.latClear || '-' }}
          </template>
        </el-table-column>
         <el-table-column
          prop="clearResult"
          width="120"
          label="清洗结果"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.clearResult || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" width="280" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" v-if="getBtnPermissionsByName('编辑')" @click="editPath(scope.row.guid)">编辑 | </a>
            <!-- <a v-if="scope.row.approveState === 'A' " class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a> -->
            <!-- <a v-if="getBtnPermissionsByName('审核')"  class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a>
            <a v-if="scope.row.approveState === 'R' ||scope.row.approveState === 'Y'" class="txt-color" @click="toReview(scope.row)">
              撤回重审 |
            </a> -->
            <a class="txt-color" v-if="getBtnPermissionsByName('查看联系人')" @click="lookPath(scope.row)">查看联系人 | </a>
            <a class="txt-color" v-if="getBtnPermissionsByName('变更日志')"   @click="changeLog(scope.row)">变更日志 | </a>
            <!-- <a class="txt-color" v-if="getBtnPermissionsByName('标记状态')" @click="openMiantainState(2, scope.row.guid)">标记状态 | </a> -->
            <a class="txt-color" v-if="getBtnPermissionsByName('详情')" @click="editPath(scope.row.guid,true)">详情 | </a>
            <a class="txt-color" v-if="getBtnPermissionsByName('删除')" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="标记维护状态" :visible.sync="dialogVisible" width="400px">
      *维护状态：
      <el-radio-group v-model="maintainState">
        <el-radio :label="0">未处理</el-radio>
        <el-radio :label="1">已维护</el-radio>
        <el-radio :label="2">无需处理</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateMiantainState()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量分配客户 -->
    <el-dialog title="批量分配客户" :visible.sync="dialogCustomer" width="550px" :close-on-click-modal="false">
      <div class="title-box">
        <div class="title-box-name"><span> </span>所属企业：</div>{{ tenantName }}
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span> </span>已选客户：</div>
        <span class="fontC-4fa1a4">{{ `${this.multipleSelection.length}家(注意: 请在上个页面确认已选择的客户)` }}</span>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>指派人员：</div>
        <el-select v-model="staffForm.staffGuid" value-key="guid" collapse-tags multiple filterable placeholder="请选择" class="w60f" @change="changeStaff">
          <el-option v-for="item in staffList"  :key="item.guid" :label="item.staffName"
            :value="item">
            <span style="float: left">{{ item.staffName }}</span>
            <span span style="float: right; color: #8492a6; font-size: 13px">{{ item.mobileNo }}</span>
          </el-option>
        </el-select>
      </div>
      <!-- <div class="title-box mt15">
        <div class="title-box-name"><span> </span>所属部门：</div>{{ organisationNames || '-'}}

      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogCustomer = false">取消</el-button>
        <el-button size="mini" v-loading.fullscreen.lock="fullscreenLoading" type="info" @click="submitFormStaff('3')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
import areaJson from '../../assets/js/china_address_v4.js';
import configuration  from './components/mixins/listMixins';
export default {
  mixins:[btnPermisson,configuration],
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 274,
      contentMainHeight: window.innerHeight - 200,
      dialogVisible: false,
      maintainState: 1,
      options: areaJson,
      updateTime: [], // 更新时间
      approveTime: [], // 审核时间
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        startTime: '',
        endTime: '',
        franchiseeName: '',
        tenantGuid: '',
        filingMethod: '',
        maintainState: '',
        property: [],
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
        belongStaffName:'',//指派人员
        isBelong:'',
        isClear: '',//是否清洗
        clearResult: '',//清洗结果
        customerNameClear: '',//更新后名称
        guid: '',//ID
      },
      tenantList: [],
      tableData: [],
      sendTime: '',
      right: 'right',
      fullscreenLoading: false,
      tableLoading: false,
      filingMethodList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '手动建档'
        },
        {
          value: '2',
          label: '自动建档'
        }
      ],
      maintenanceStatusList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '未处理'
        },
        {
          value: '1',
          label: '已维护'
        },
        {
          value: '2',
          label: '无需处理'
        }
      ],
      franchiseeTypeList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '一级经销商',
          label: '一级经销商'
        },
        {
          value: '二级经销商',
          label: '二级经销商'
        },
        {
          value: '垂直商业公司',
          label: '垂直商业公司'
        },
        {
          value: '城市商业公司',
          label: '城市商业公司'
        },
        {
          value: '战略商业公司',
          label: '战略商业公司'
        }
      ],
      approveStateOp: [
        {
          text: '待审核',
          value: 'A',
        },
        {
          text: '已通过',
          value: 'Y',
        },
        {
          text: '已驳回',
          value: 'R',
        },
      ],
      bizStateOp: [
       
        {
          value: "S",
          text: "停用",
        },
        {
          value: "Y",
          text: "启用",
        },
      ],
      bizStateObj: {
        S: '停用',
        Y: '启用',
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
        S: 'danger',
      },
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
      multipleSelectionGuid: [],
      multipleSelection: [],
      num: '',
      //新增分配
      dialogCustomer: false,
      tenantName: '',
      organisationNames: '',
      staffList: [],
      staffForm: {
        guids: [],
        staffGuid: [],
        userGuid: '',
        staffName: ''
      },
      isBelongOp: [
        {
          value: "",
          text: "全部",
        },
        {
          value: "Y",
          text: "是",
        },
        {
          value: "N",
          text: "否",
        },
      ],
      /**是否已清洗 */
      isClearList: [
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      /**清洗结果 */
      clearResultList: [
        {
          value: "正常",
          label: "正常",
        },
        {
          value: "异常",
          label: "异常",
        },
      ],
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 340;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 274;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  activated() {
    if (this.page.tenantGuid) {
      this.getData(false);
    }
  },
  created() {
    this.getTenantOperationRelList(true);
    //按钮权限
    this.getMenuList();
  },
  methods: {
    
    //点击行选中
    handleClickTableRow(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //批量分配
    batchCustomer() {
      if (!this.page.tenantGuid) {
        this.$message.error('请先选择所属企业！')
        return
      }
      if (!this.tableData.length) {
        this.$message.error('暂无数据！')
        return
      }
      if (!this.multipleSelection.length) {
        this.$message.error('请勾选数据！');
        return
      }
      this.dialogCustomer = true;
    },
    //数据清洗导入
    cleanImport() {
      this.$router.push({
        path: '/dataCleaningImport',
        query: {
          type: '0045',
        }
      })
    },
    //批量停用、启用
    batchChangeState(flg) {
      // flg为停用(s)启用(Y)状态
      let str=''
      let tips=''
      let self = this;
      if (!this.multipleSelection.length) {
        this.$message.error("请勾选数据！");
        return;
      }
      if(flg==='S'){
        str='停用后，客户信息将不被服务人员看到，确定操作吗？'
        tips='批量停用成功'
      }else{
        str='启用后，负责该客户的服务人员将可以看到此信息，确定操作吗？'
        tips='批量启用成功'
      }
      
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        self.api
            .put(
              `/${serverConfig.msCustomerService}/common/update-biz-state?bizState=${flg}&customerType=2`,
              self.multipleSelection
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(tips);
                self.$refs.multipleTable.clearSelection();
                self.getData(false);
              } else {
                self.$message.error(res.data.msg);
              }
            });
      })
    },
    companyChange(val) {
      this.getStaff()
      this.tenantList.forEach(i => {
        if (i.sendTenantGuid == val) {
          this.tenantName = i.sendTenantName;
        }
      })
    },
    changeStaff(val) {
    },
    getTenantOperationRelList(flg) {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` + '&tenantGuid=' + localStorage.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelectionGuid.length == 0) {
          self.$message.error('请勾选数据！');
          return
        }
      } else {
        self.multipleSelectionGuid = [];
        self.multipleSelectionGuid.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/franchisee/data/delete`, self.multipleSelectionGuid).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              this.$refs.multipleTable.clearSelection();
              self.dialogVisible = false;
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    openMiantainState(flg, guid) {
      if (flg == 1) {
        if (this.multipleSelection.length == 0) {
          this.$message.error('请勾选数据！');
          return
        }
      }
      this.dialogVisible = true;
      this.MiantainStateflg = flg;
      this.MiantainStateGuid = guid;
    },
    updateMiantainState() {
      let self = this;
      let guids = [];
      if (self.MiantainStateflg == 2) {
        self.multipleSelection = [];
        self.multipleSelection.push(self.MiantainStateGuid);
      }
      this.$confirm('此操作将永久标记, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.put(`/${serverConfig.msCustomerService}/common/update-maintain-state?customerType=3&maintainState=` + self.maintainState, self.multipleSelection).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('标记成功');
              this.$refs.multipleTable.clearSelection();
              this.dialogVisible = false;
              self.getData(false);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    empty() {
      let self = this;
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        startTime: '',
        endTime: '',
        franchiseeName: '',
        tenantGuid: this.page.tenantGuid,
        filingMethod: '',
        maintainState: '',
        property: [],
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
        belongStaffName:'',//指派人员
        isBelong:'',
        isClear: '',//是否清洗
        clearResult: '',//清洗结果
        guid: '',//ID
      },

      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if(!this.page.tenantGuid) {
        this.$message.warning('请选择所属公司')
        return;
      } 
      if(!this.page.bizStateList.length){
        this.page.bizStateList=['Y','S']
      }
      if(self.multipleSelection && self.multipleSelection.length > 0){
        self.$refs.multipleTable.clearSelection();
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/franchisee/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addPath() {
      this.$router.push({
        path: '/commercialCompanyinquiryDetail/detail',
        query: { tenantGuid: this.page.tenantGuid, productGuid:this.$route.query.productGuid }
      });
    },
    editPath(guid,disabled) {
      this.$router.push({
        path: '/commercialCompanyinquiryDetail/detail',
        query: {disabled, guid: guid, tenantGuid: this.page.tenantGuid , productGuid:this.$route.query.productGuid}
      });
    },
    // 去审核
    toReview(item) {
      this.$router.push({
        path: `/commercialCompanyAudit`,
        query: {
          guid: item.guid,
          tenantGuid: this.page.tenantGuid,
          productGuid: this.$route.query.productGuid,

        },
      });
    },
    lookPath(row) {
      this.$router.push({
        path: '/businessCustomerList',
        query: { tenantGuid: this.page.tenantGuid,clientType:'10', franchiseeName: row.franchiseeName, productGuid:this.$route.query.productGuid }
      });
    },
    batchImport(guid) {
      // this.$router.push({ path: '/importCommercialCompany'});
      this.$router.push({ 
        path: '/importNewManagementList',
        query:{ 
          productGuid:this.$route.query.productGuid,
          type:'0009',
          tenantGuid:this.page.tenantGuid
        } 
      });
      
    },
    batchStateImport() {
      this.$router.push({
        path: "/importNewStateList",
        query:{ 
          productGuid:this.$route.query.productGuid,
          type:'0028',
          tenantGuid:this.page.tenantGuid
        } 
      });
    },
    report() {
      let self = this;
      self.fullscreenLoading = true;
      // self.page.pageSize = -1;
      let query = JSON.parse(JSON.stringify(self.page));
      query.pageSize = -1;
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      self.api.postJson(`/${serverConfig.msCustomerService}/franchisee/data/export-franchisee-report`, query).then(res => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.fullscreenLoading = true;
      self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, { 'colNames': colNames, 'datas': datas, 'sheetName': sheetName, 'fileNam': fileNam })
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
      // self.empty();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
        self.staffForm.guids.push(item.guid)
      });
      console.log(val);
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getbelongStaffsName(row) {
      let { belongStaffs } = row
      if (Array.isArray(belongStaffs) && belongStaffs.length) {
        return belongStaffs.length > 2 ? `${((belongStaffs.slice(0, 2)).map(item=>item.staffName)).join()}等${belongStaffs.length}人` : (belongStaffs.map(item=>item.staffName)).join()
      } else {
        return '-'
      }
    },
    //跳转页面
    changeLog(row) {
      console.log(row);
      this.$router.push({
        path: "/businessLogs",
        query: {
          customerName: row.franchiseeName,
          customerGuid: row.guid,
          productGuid: this.$route.query.productGuid,
          configName : 'JDSYGS_CONFIG'
        },
      });
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #DCDFE6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  width: 72px;
  text-align:right
}
.ipt-sty{
  flex: 1;
}
.el-col-6{
  display: flex;
  word-break: keep-all;
}
</style>
